// extracted by mini-css-extract-plugin
module.exports = {"listHolder-cover":"DropdownMenu_listHolder-cover__2Cx-U","listHolder":"DropdownMenu_listHolder__2kj59"};